import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { IInjectedRootStore, RequiredFeatures } from 'stores';

interface IRestrictedElementProps {
    requires: RequiredFeatures;
    children: React.ReactElement;
}

@inject('rootStore')
@observer
export class RestrictedRoute extends React.Component<IRestrictedElementProps> {
    public render(): React.ReactElement {
        return this.isAllowed ? this.props.children : <Navigate to="/" replace />;
    }
    private get injected(): IInjectedRootStore {
        return this.props as IRestrictedElementProps & IInjectedRootStore;
    }
    private get isAllowed(): boolean {
        switch (this.props.requires) {
            case 'DEV':
                return this.injected.rootStore.isDev();
            case 'ADMIN':
                return this.injected.rootStore.isAdmin();
            default:
                return true;
        }
    }
}
